import styled from 'styled-components';

interface PaginationProps {
  justifyContent?: string;
  alignItems?: string;
  marginTop?: string;
  padding?: string;
  background?: string;
  borderRadius?: string;
  boxShadow?: string;
}

export const Pagination = styled.div<PaginationProps>`
  display: flex;
  justify-content: ${props => props.justifyContent || 'space-between'};
  align-items: ${props => props.alignItems || 'center'};
  margin-top: ${props => props.marginTop || '2rem'};
  padding: ${props => props.padding || '1rem'};
  background: ${props => props.background || 'white'};
  border-radius: ${props => props.borderRadius || '8px'};
  box-shadow: ${props => props.boxShadow || '0 2px 4px rgba(0, 0, 0, 0.1)'};
`;

export const PaginationButton = styled.button`
  padding: 8px 16px;
  border: 1px solid #e1e8ed;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  color: #374151;

  &:hover:not(:disabled) {
    background: #f8f9fa;
    border-color: #667eea;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
  }
`;

export const PaginationInfo = styled.span`
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 500;
`;